import React, {
  createContext,
  memo,
  useContext,
  useMemo,
  useState,
} from "react";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import useTranscriptEntities from "../hooks/useTranscriptEntities";

const GradeLevelsContext = createContext();

const GradeLevelsProvider = memo(({ children, studentId }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    academicYears,
    gradingPeriods,
    customGradingPeriods,
    isLoading,
    schools,
    grades,
    customGrades,
  } = useTranscriptEntities();

  const value = useMemo(
    () => ({
      isEditMode,
      setIsEditMode,
      setLoading,
      academicYears,
      gradingPeriods,
      customGradingPeriods,
      isLoading,
      schools,
      grades,
      customGrades,
      studentId,
    }),
    [
      academicYears,
      customGradingPeriods,
      gradingPeriods,
      isEditMode,
      isLoading,
      schools,
      grades,
      customGrades,
      studentId,
    ]
  );

  return (
    <GradeLevelsContext.Provider value={value}>
      {children}
      {loading ? <FullScreenLoader /> : null}
    </GradeLevelsContext.Provider>
  );
});

GradeLevelsProvider.displayName = "GradeLevelsProvider";

const useGradeLevelsContext = () => useContext(GradeLevelsContext);

export { GradeLevelsProvider, useGradeLevelsContext };
